export enum DeliveryPromiseType {
    ONE_TIME_PROMISE = "PROMISE_TYPE_ON_TIME",
}

export interface IDeliveryPromise {
    type: DeliveryPromiseType;
}
